import React from "react";
import styled from "styled-components";

import zap from "../../images/whatsapp.png";
import zapMenor from "../../images/whatsappMenor.png";

const Container = styled.div`
  width: 100%;

  position: fixed;
  left: 15rem;
  top: 15rem;
  z-index: 1000;

  @media (min-height: 410px) {
    top: 18rem;
  }
  @media (min-height: 450px) {
    top: 20rem;
  }
  @media (min-height: 480px) {
    top: 22rem;
  }
  @media (min-height: 550px) {
    top: 24rem;
  }
  @media (min-height: 590px) {
    top: 27rem;
  }
  @media (min-height: 620px) {
    top: 30rem;
  }
  @media (min-height: 650px) {
    top: 33rem;
  }
  @media (min-height: 680px) {
    top: 35rem;
  }
  @media (min-height: 730px) {
    top: 38rem;
  }
  @media (min-height: 760px) {
    top: 40rem;
  }
  @media (min-height: 820px) {
    top: 43rem;
  }

  @media (min-height: 850px) {
    top: 45rem;
  }

  //Altura
  @media (max-width: 1020px) {
    display: none;
  }

  @media (min-width: 500px) {
    left: 19rem;
  }

  @media (min-width: 580px) {
    left: 22rem;
  }
  @media (min-width: 680px) {
    left: 25rem;
  }
  @media (min-width: 720px) {
    left: 28rem;
  }
  @media (min-width: 800px) {
    left: 32rem;
  }
  @media (min-width: 850px) {
    left: 36rem;
  }
  @media (min-width: 900px) {
    left: 40rem;
  }
  @media (min-width: 950px) {
    left: 44rem;
  }
  @media (min-width: 1000px) {
    left: 52rem;
  }
  @media (min-width: 1050px) {
    left: 54rem;
  }
  @media (min-width: 1110px) {
    left: 56rem;
  }
  @media (min-width: 1150px) {
    left: 58rem;
  }

  @media (min-width: 1200px) {
    left: 60rem;
  }
  @media (min-width: 1230px) {
    left: 62rem;
  }
  @media (min-width: 1250px) {
    left: 64rem;
  }
  @media (min-width: 1300px) {
    left: 66rem;
  }
  @media (min-width: 1350px) {
    left: 68rem;
  }
  @media (min-width: 1400px) {
    left: 70rem;
  }

  @media (min-width: 1450px) {
    left: 73rem;
  }
  @media (min-width: 1500px) {
    left: 76rem;
  }
  @media (min-width: 1550px) {
    left: 78rem;
  }
  @media (min-width: 1600px) {
    left: 80rem;
  }
  @media (min-width: 1650px) {
    left: 82rem;
  }
  @media (min-width: 1750px) {
    left: 84rem;
  }
  @media (min-width: 1850px) {
    left: 86rem;
  }
  @media (min-width: 1950px) {
    left: 94rem;
  }
  @media (min-width: 2050px) {
    left: 100rem;
  }
  @media (min-width: 2150px) {
    left: 106rem;
  }
  @media (min-width: 2250px) {
    left: 112rem;
  }
  @media (min-width: 2350px) {
    left: 116rem;
  }
  @media (min-width: 2450px) {
    left: 120rem;
  }
  @media (min-width: 2550px) {
    left: 124rem;
  }
  @media (min-width: 2650px) {
    left: 128rem;
  }
  @media (min-width: 2750px) {
    left: 132rem;
  }
  @media (min-width: 2850px) {
    left: 136rem;
  }
`;
const ContainerMenor = styled.div`
  width: 100%;

  position: fixed;
  left: 14rem;

  z-index: 1000;
  @media (max-height: 700px), (max-width: 600px) {
    display: none;
  }
  @media (min-height: 410px) {
    top: 18rem;
  }
  @media (min-height: 450px) {
    top: 20rem;
  }
  @media (min-height: 480px) {
    top: 22rem;
  }
  @media (min-height: 550px) {
    top: 24rem;
  }
  @media (min-height: 590px) {
    top: 27rem;
  }
  @media (min-height: 620px) {
    top: 30rem;
  }
  @media (min-height: 650px) {
    top: 33rem;
  }
  @media (min-height: 680px) {
    top: 35rem;
  }
  @media (min-height: 730px) {
    top: 38rem;
  }
  @media (min-height: 760px) {
    top: 40rem;
  }
  @media (min-height: 820px) {
    top: 45rem;
  }
  @media (min-height: 900px) {
    top: 48rem;
  }

  @media (min-width: 350px) {
    left: 18rem;
  }
  @media (min-width: 400px) {
    left: 20rem;
  }
  @media (min-width: 460px) {
    left: 25rem;
  }
  @media (min-width: 530px) {
    left: 29rem;
  }
  @media (min-width: 590px) {
    left: 30rem;
  }
  @media (min-width: 640px) {
    left: 35rem;
  }
  @media (min-width: 680px) {
    left: 37rem;
  }
  @media (min-width: 730px) {
    left: 40rem;
  }

  @media (min-width: 800px) {
    left: 43rem;
  }
  @media (min-width: 830px) {
    left: 45rem;
  }
  @media (min-width: 890px) {
    left: 48rem;
  }
  @media (min-width: 920px) {
    left: 50rem;
  }
  @media (min-width: 1021px) {
    display: none;
  }
`;

const Imagem = styled.img`
  background-repeat: no-repeat;
  background-position: center;
  // display: none;
  width: 20%;
  @media (min-width: 680px) {
    width: 20%;
  }
  @media (min-width: 800px) {
    width: 20%;
  }
  @media (min-width: 1100px) {
    width: 20%;
  }
`;
const ImagemMenor = styled.img`
  background-repeat: no-repeat;
  background-position: center;
  width: 15%;
  @media (min-width: 680px) {
    width: 15%;
  }
  @media (min-width: 800px) {
    width: 15%;
  }
`;

export default function ContatoZap() {
  return (
    <>
      <Container>
        <a
          href="https://wa.me/message/H7PTB2XYZUDAO1"
          target="_blank"
          id="zap"
          rel="noreferrer"
        >
          <Imagem src={zap} />
        </a>
      </Container>
      <ContainerMenor>
        <a
          href="https://wa.me/message/H7PTB2XYZUDAO1"
          target="_blank"
          id="zap"
          rel="noreferrer"
        >
          <ImagemMenor src={zapMenor} />
        </a>
      </ContainerMenor>
    </>
  );
}
